import React from "react";

export const SlotContext = React.createContext();